<template>
  <b-container>
    <b-row>
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="danger" :msg="alert.error" />
    </b-row>
    <h2>{{ $t("tripPlan.createWaypoint") }}</h2>
    <waypoint-crud :model="model" :modelstate="modelstate"></waypoint-crud>
    <b-button @click="save()" :disabled="submitted">
      {{ $t("geral.save") }}
    </b-button>
  </b-container>
</template>
<script>
export default {
  name: "WaypointCreate",
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    waypointCrud: () =>
      import("@/components_rms/workflow/Waypoint/WaypointCrud.vue"),
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Ponto de parada criado com sucesso",
      },
      model: {
        id: 0,
        companyDucumentNumber: "",
        name: "",
        fullAddress: "",
        latitude: 0.0,
        longitude: 0.0,
        active: false,
      },
      modelstate: {},
      submitted: false,
    };
  },
  methods: {
    save() {
      this.submitted = true;
      this.$apiWorkflow
        .post("/waypoint/save/", this.model)
        .then((response) => {
          // console.log(response);
          this.$refs.alert.show();
          this.model = {
            id: 0,
            companyDucumentNumber: "",
            name: "",
            fullAddress: "",
            latitude: 0.0,
            longitude: 0.0,
            active: false,
          };
          this.submitted = false;
        })
        .catch((error) => {
          console.log(error.response);
          this.submitted = false;
          this.alert.error =
            error.response.status + " - " + error.response.data.errorMessage
;
          this.$refs.danger.show();
        });
    },
  },
};
</script>
